const { INCLUDED_SC_NAVIGATION_TILES_TESTED_OUT, INCLUDED_SC_NAVIGATION_TILES_TEST } = require('./constants');

const isIdInTest = (id) => INCLUDED_SC_NAVIGATION_TILES_TEST.includes(id);

const shoudlShowTileCaoursel = ({ isTouch, inServiceFiltersTest, subCategoryId, nestedSubCategoryId, subCatFiltersCarousel }) =>
    !isTouch && subCatFiltersCarousel && (INCLUDED_SC_NAVIGATION_TILES_TESTED_OUT.includes(subCategoryId) ||
    inServiceFiltersTest && (isIdInTest(subCategoryId) || isIdInTest(nestedSubCategoryId)));

module.exports = {
    shoudlShowTileCaoursel,
    isIdInTest
};
